export default __webpack_public_path__ + "static/media/success-check-mark.8cefb1e1.png";